import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DropdownOption } from '@app/storybook/components/dropdown/dropdown.component';
import { CheckoutContentExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { Shop } from '@app/services/shops/shop.model';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'checkout-content-settings',
  templateUrl: './checkout-content-settings.component.html',
  styleUrls: ['./checkout-content-settings.component.scss'],
  standalone: false,
})
export class CheckoutContentSettingsComponent {
  @Input() formGroup: UntypedFormGroup;
  @Input() usageTokenControl: UntypedFormControl;
  @Input() shop$: Observable<Shop>;
  @Input() shopCurrencySymbol: string;
  @Input() dynamicFieldsAutocompleteOptions$: BehaviorSubject<any[]>;
  @Input() defaultIconUrl: string;
  @Input() placementModeConfig: any[];
  @Input() styleOptions: DropdownOption[];
  @Input() blockTypeOptions: DropdownOption[];
  @Input() borderTypeOptions: DropdownOption[];
  @Input() borderWidthOptions: DropdownOption[];
  @Input() cornerRadiusOptions: DropdownOption[];
  @Input() paddingOptions: DropdownOption[];
  @Input() MIN_BLOCKS: number;
  @Input() MAX_BLOCKS: number;

  @Output() styleTypeChange = new EventEmitter<DropdownOption>();
  @Output() blockTypeChange = new EventEmitter<{ option: DropdownOption; index: number }>();
  @Output() previewChange = new EventEmitter<{ imagePreviewBase64: string; index: number }>();
  @Output() clearImage = new EventEmitter<number>();
  @Output() checkUrl = new EventEmitter<string>();

  BlockType = CheckoutContentExtension.BlockType;

  onStyleTypeChange(option: DropdownOption) {
    this.styleTypeChange.emit(option);
  }

  onBlockTypeChange(option: DropdownOption, index: number) {
    this.blockTypeChange.emit({ option, index });
  }

  onPreviewChange(imagePreviewBase64: string, index: number) {
    this.previewChange.emit({ imagePreviewBase64, index });
  }

  onClearImage(index: number) {
    this.clearImage.emit(index);
  }

  onCheckUrl(url: string) {
    this.checkUrl.emit(url);
  }
}
